module.exports = __webpack_public_path__ + "img/remark.6ece4063.png";